// Module
var code = "<svg viewBox=\"0 0 20 20\" fill=currentColor> <path fill-rule=evenodd d=\"M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1z\" clip-rule=evenodd /> </svg> ";
// Exports
module.exports = code;